import React from "react";
import styles from "./ActiveStatusComponent.module.scss";

const ActiveStatusComponent = ({ active }) => {
  return (
    <div className={active ? styles.days_ago : styles.inactive}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_423_954)">
          <path
            d="M8.00065 14.6673C11.6825 14.6673 14.6673 11.6825 14.6673 8.00065C14.6673 4.31875 11.6825 1.33398 8.00065 1.33398C4.31875 1.33398 1.33398 4.31875 1.33398 8.00065C1.33398 11.6825 4.31875 14.6673 8.00065 14.6673Z"
            stroke={active ? `#39AC3B` : "#ff3434"}
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8 4V8L10.6667 9.33333"
            stroke={active ? `#39AC3B` : "#ff3434"}
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_423_954">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
      {/* {day} days ago */}
      <p className={styles.day}>{active ? "Active" : "Inactive"}</p>
    </div>
  );
};

export default ActiveStatusComponent;
